import { motion } from 'framer-motion'
import CanvasLogo from 'apps/builder/assets/canvas-logo.svg'

export const ContainerEnterExitAnimation = ({
  children,
  el = 'div',
  customConfig = {},
  ...rest
}) => {
  const Animation = motion[el]
  const baseAnimationConfig = {
    initial: { opacity: 0, y: -50, scale: 0.2 },
    animate: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0, scale: 0.2, transition: { duration: 0.3 } },
  }

  const animationConfig = Object.assign({}, baseAnimationConfig, customConfig)

  return (
    <Animation positionTransition {...animationConfig} {...rest}>
      {children}
    </Animation>
  )
}

export const ContainerSlideDownAnimation = ({
  children,
  el = 'div',
  customConfig = {},
  ...rest
}) => {
  const Animation = motion[el]
  const baseAnimationConfig = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  }

  const animationConfig = Object.assign({}, baseAnimationConfig, customConfig)

  return (
    <Animation positionTransition {...animationConfig} {...rest}>
      {children}
    </Animation>
  )
}

export const ContainerSlideInAnimation = ({
  children,
  el = 'div',
  customConfig = {},
  ...rest
}) => {
  const Animation = motion[el]
  const baseAnimationConfig = {
    initial: { x: 150, opacity: 0.65, scale: 0.75 },
    animate: { x: 0, opacity: 1, scale: 1, transition: { duration: 0.3 } },
    exit: { opacity: 0, scale: 0.2, transition: { duration: 1 } },
  }

  const animationConfig = Object.assign({}, baseAnimationConfig, customConfig)

  return (
    <Animation positionTransition {...animationConfig} {...rest}>
      {children}
    </Animation>
  )
}

export const Loading = () => <CanvasLogo className="loading--logo" />

export const CustomLoading = ({ logoUrl, loadingText = 'Loading...' }) => {
  
  return (
    <div className="loading--logo custom">
      <img src={logoUrl} />

      <h2>{loadingText}</h2>
    </div>
  )
}
